import { render } from "./AliquotTableComponent.vue?vue&type=template&id=66f0c8a0&scoped=true"
import script from "./AliquotTableComponent.vue?vue&type=script&lang=js"
export * from "./AliquotTableComponent.vue?vue&type=script&lang=js"

import "./AliquotTableComponent.vue?vue&type=style&index=0&id=66f0c8a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f0c8a0"]])

export default __exports__